import { render, staticRenderFns } from "./GenericReviewCard.vue?vue&type=template&id=da0cf6b0"
import script from "./GenericReviewCard.vue?vue&type=script&lang=js"
export * from "./GenericReviewCard.vue?vue&type=script&lang=js"
import style0 from "./GenericReviewCard.vue?vue&type=style&index=0&id=da0cf6b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports